import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";

export default function ProtectedRoute({ roles }) {
    const { user } = useApp();
    const location = useLocation();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="text-muted-foreground" data-testid="auth-loading">…</div>
            </div>
        );
    }
    if (user === false) {
        // Staff-only routes → staff login. Owner/Manager routes → owner login.
        const isStaffOnly = roles && roles.every((r) => ["cashier", "waiter", "kitchen", "driver"].includes(r));
        const hasStaffRole = roles && roles.some((r) => ["cashier", "waiter", "kitchen", "driver"].includes(r));
        const loginPath = isStaffOnly || hasStaffRole ? "/staff-login" : "/login";
        return <Navigate to={loginPath} replace state={{ from: location }} />;
    }
    if (roles && !roles.includes(user.role)) {
        return <Navigate to="/" replace />;
    }
    return <Outlet />;
}
